import DashboardLayout from "src/pages/Dashboard/Layout/DashboardLayout.vue";
// GeneralViews
import NotFound from "src/pages/GeneralViews/NotFoundPage.vue";
// Dashboard pages
import Overview from "src/pages/Dashboard/Dashboard/Overview.vue";

// Pages
import Login from "src/pages/Dashboard/Pages/Login.vue";
import SaleStartedPlan from "src/pages/Dashboard/Pages/SaleStartedPlan.vue";
import PaymentStartPlan from "src/pages/Dashboard/Pages/PaymentStartPlan.vue";
import PaymentStartNow from "src/pages/Dashboard/Pages/PaymentStartNow.vue";
import PaymentBilletStartPlan from "src/pages/Dashboard/Pages/PaymentBilletStartPlan.vue";
import PaymentDebitStartPlan from "src/pages/Dashboard/Pages/PaymentDebitStartPlan.vue";
import PaymentToolsPlan from "src/pages/Dashboard/Pages/PaymentToolsPlan.vue";
import Register from "src/pages/Dashboard/Pages/Register.vue";
import Register2 from "src/pages/Dashboard/Pages/Register2.vue";
import RegisterRecurringUser from "src/pages/Dashboard/Pages/RegisterRecurringUser.vue";
import RegisterFreeUser from "src/pages/Dashboard/Pages/RegisterFreeUser.vue";
import User from "src/pages/Dashboard/Pages/UserProfile.vue";
import Course from "src/pages/Dashboard/Pages/Course.vue";
import Workshop from "src/pages/Dashboard/Pages/Workshop.vue";
import ConferenceRoom from "src/pages/Dashboard/Pages/ConferenceRoom.vue";
import Performance from "src/pages/Dashboard/Pages/Performance.vue";
import Cataloging from "src/pages/Dashboard/Pages/Cataloging.vue";
import AllCataloging from "src/pages/Dashboard/Pages/AllCataloging.vue";
import ManualCataloging from "src/pages/Dashboard/Pages/ManualCataloging.vue";
import NewManualCataloging from "src/pages/Dashboard/Pages/NewManualCataloging.vue";
import Notice from "src/pages/Dashboard/Pages/Notice.vue";
import FAQ from "src/pages/Dashboard/Pages/FAQ.vue";
import Terms from "src/pages/Dashboard/Pages/Terms.vue";
import Sac from "src/pages/Dashboard/Pages/Sac.vue";
import ConferenceRoomEvaluation from "src/pages/Dashboard/Pages/ConferenceRoomEvaluation.vue";
import Signature from "src/pages/Dashboard/Pages/Signature.vue";
import OtherFullCalendar from "src/pages/Dashboard/Calendar/OtherFullCalendar.vue";
import TradingSystemFullCalendar from "src/pages/Dashboard/Pages/TradingSystem.vue";
import PrivacityPolice from "src/pages/Dashboard/Pages/PrivacityPolice.vue";

let registerPage = {
  path: "/registeruser",
  name: "Register",
  component: Register,
  meta: {
    auth: false
  }
};

let registerPage2 = {
  path: "/planotop",
  name: "PlanoTop",
  component: Register2,
  meta: {
    auth: false
  }
};

let saleStart = {
  path: "/promocional",
  name: "Inscrição de Assinatura Promocional",
  component: SaleStartedPlan,
  meta: {
    auth: false
  }
};

let paymentStartNow = {
  path: "/startnow",
  name: "Inscrição de Assinatura Promocional",
  component: PaymentStartNow,
  meta: {
    auth: false
  }
};

let paymentStart = {
  path: "/start",
  name: "Inscrição de Assinatura Promocional",
  component: PaymentStartPlan,
  meta: {
    auth: false
  }
};

let paymentBilletStart = {
  path: "/boleto/start",
  name: "Inscrição de Assinatura Promocional com boleto",
  component: PaymentBilletStartPlan,
  meta: {
    auth: false
  }
};

let paymentDebitStart = {
  path: "/debito/start",
  name: "Inscrição de Assinatura Promocional com debito",
  component: PaymentDebitStartPlan,
  meta: {
    auth: false
  }
};

let privacityPolice = {
  path: "/politica_de_privacidade",
  name: "Politica de Privacidade da Assinatura Promocional",
  component: PrivacityPolice,
  meta: {
    auth: false
  }
};

let paymentTools = {
  path: "/start360",
  name: "Inscrição de Assinatura para Ferramentas",
  component: PaymentToolsPlan,
  meta: {
    auth: false
  }
};

let registerRecurringUserPage = {
  path: "/assine/:planId?/:salesmanId?",
  name: "Inscrição Assinatura",
  component: RegisterRecurringUser,
  props: route => ({
    planId: route.params.planId ? route.params.planId : null,
    salesmanId: route.params.salesmanId ? route.params.salesmanId : null
  }),
  meta: {
    auth: false
  }
};

let registerFreeUserPage = {
  path: "/registerfreeuser",
  name: "RegisterFreeUser",
  component: RegisterFreeUser,
  meta: {
    auth: false
  }
};

let conferenceRoomEvaluationPage = {
  path: "/confroomevaluation",
  name: "ConferenceRoomEvaluation",
  component: ConferenceRoomEvaluation,
  meta: {
    auth: false
  }
};

let catalogingPage = {
  path: "/cataloging",
  name: "Catalogação Teoria Cutrim",
  component: Cataloging,
  meta: {
    auth: true
  }
};

let allCatalogingPrivatePage = {
  path: "/all-cataloging",
  name: "Catalogação Demais Indicadores",
  component: AllCataloging,
  meta: {
    auth: true
  }
};

let manualCatalogingPage = {
  path: "/manualcataloging",
  name: "Old Catalogação Manual Teoria Cutrim",
  component: ManualCataloging,
  meta: {
    auth: true
  }
};

let newManualCatalogingPage = {
  path: "/catalogacao_manual",
  name: "New Catalogação Manual Teoria Cutrim",
  component: NewManualCataloging,
  meta: {
    auth: true
  }
};

const routes = [
  {
    path: "/login",
    component: Login,
    meta: {
      auth: false
    }
  },
  registerPage,
  registerPage2,
  saleStart,
  paymentStartNow,
  paymentStart,
  paymentBilletStart,
  paymentDebitStart,
  privacityPolice,
  paymentTools,
  registerRecurringUserPage,
  registerFreeUserPage,
  conferenceRoomEvaluationPage,
  catalogingPage,
  allCatalogingPrivatePage,
  manualCatalogingPage,
  newManualCatalogingPage,
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard",
    meta: {
      auth: true
    },
    children: [
      {
        path: "user",
        name: "Meu Perfil",
        component: User,
        meta: {
          auth: true
        }
      },
      {
        path: "fullcalendar_trading_system",
        name: "Trading System",
        component: OtherFullCalendar,
        meta: {
          auth: true
        }
      },
      {
        path: "dashboard",
        name: "Dashboard",
        component: Overview,
        meta: {
          auth: true
        }
      },
      {
        path: "courses",
        name: "Nivelamento",
        component: Course,
        meta: {
          auth: true
        }
      },
      {
        path: "workshop",
        name: "Especializações",
        component: Workshop,
        meta: {
          auth: true
        }
      },
      {
        path: "conferenceroom",
        name: "Grupos de Estudos",
        component: ConferenceRoom,
        meta: {
          auth: true
        }
      },
      {
        path: "performance",
        name: "Ferramentas",
        component: Performance,
        meta: {
          auth: true
        }
      },
      {
        path: "notices",
        name: "Avisos",
        component: Notice,
        meta: {
          auth: true
        }
      },
      {
        path: "faq",
        name: "FAQ",
        component: FAQ,
        meta: {
          auth: true
        }
      },
      {
        path: "terms",
        name: "Políticas & Termos",
        component: Terms,
        meta: {
          auth: true
        }
      },
      {
        path: "sac",
        name: "SAC",
        component: Sac,
        meta: {
          auth: true
        }
      },
      {
        path: "signature",
        name: "Minhas Assinaturas",
        component: Signature,
        meta: {
          auth: true
        }
      }
      // {
      //   path: 'sweet',
      //   name: 'teste modals',
      //   component: Sweet,
      //   meta: {
      //     auth: true
      //   }
      // }
    ]
  },
  { path: "*", component: NotFound }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/routes.js